<script setup>
import { onMounted, ref, defineProps } from 'vue';
import { KNOLIA } from '@/knolia';
import { Gems } from '@/gems';
import { useRouter } from "vue-router"
import { MESSAGES } from '../messages';
import { useUserStore } from '../store/modules/user'

const savedLists = ref([])
const selectedList = ref([])
const props = defineProps({
    searchUsersStore: { type: Object, required: true }
})
const router = useRouter()
const userStore = useUserStore()

async function GetSavedLists() {
    const response = await KNOLIA.CallBackEnd('get', 'get-operations', {
        params: {
            get: "saved-lists",
        }
    })

    savedLists.value = response.data
}

function ShowList(list) {
    selectedList.value = list
}

async function RemoveFromHistory(id){
    await KNOLIA.CallBackEnd('post', 'set-operations&get=remove-from-history', {
        params: {
            historyId: id,
        }
    })

    savedLists.value = savedLists.value.filter(elem => elem.id != id)
    if(selectedList.value.id == id)
        selectedList.value = []
}

function ToSkillCard(user) {
    props.searchUsersStore.SetHistoryData(selectedList.value)
    KNOLIA.SetRequestedUserId(user.id)
    router.push('/skill-card')
}

function CheckAllLists(selfChk) {
    savedLists.value.forEach(list => {
        list.export = selfChk
    });
}

async function ExportLists() {
    let checkedList = 0

    savedLists.value.forEach(list => {
        if(list.export)
            checkedList++
    })
    
    if(checkedList == 0) {
        Gems.Telegram(MESSAGES.ERROR.NO_LIST_CHECKED, 'tele-not-allowed')
        return
    }

    Gems.Telegram(MESSAGES.INFO.BROWSER_WARNING, 'tele-success')

    const res = await KNOLIA.CallBackEnd('post', 'export-saved-lists', { savedLists: savedLists.value })

    Gems.ExportExcel(res.data)
}

function UserInfoTooltip(user, divUser) {
    let tooltipText = ''

    user.criterias.forEach(criterias => {
        tooltipText += `${criterias.criteria_desig} | ${criterias.proficiency ?? '--'} | ${criterias.validation_percent ?? '0.00'}%\r\n`
    })
    Gems.Tooltip(divUser, tooltipText, 'tooltip tooltip-left')
}

onMounted(() => {
    GetSavedLists()
    if(props.searchUsersStore.ListSelected)
        selectedList.value = props.searchUsersStore.ListSelected
})

</script>


<template>

    <div class="div-container row p-0 m-0">
        <div class="col-12 col-md-6 p-0 m-0 pe-sm-1 pe-md-1">
            <span class="fw-bold div-default-title">Listas</span>

            <div class="scrollbar list group-frame">
                <div class="div-list cursor-pointer" :class="{'bg-alt-line': i % 2 == 0}" v-for="(list, i) in savedLists" :key="list.id">
                    <div @click="ShowList(list)" @mouseenter="Gems.Tooltip($event.target, list.criterias, 'tooltip tooltip-left')">
                        <input type="checkbox" class="cursor-pointer" v-model="list.export" @click.stop/>
                        <span>{{ list.date }}</span>
                        <span>{{ list.designation }}</span>
                    </div>

                    <span>
                        <i class="fas fa-trash" @click="RemoveFromHistory(list.id)" @mouseenter="Gems.Tooltip($event.target, 'Remover lista', 'tooltip')"></i>
                    </span>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-6 p-0 m-0 ps-sm-1 ps-md-1">
            <span class="fw-bold div-default-title">Pessoas [{{ selectedList.designation ?? 'Escolha uma lista' }}]</span>

            <div class="scrollbar list group-frame">
                <div class="div-header fw-bold cursor-default">
                    <div class="row col-11">
                        <span class="col-6">Nome</span>
                        <span class="col-3 text-center">Proficiência</span>
                        <span class="col-2 text-center">Ajustamento</span>
                    </div>
                    <span class="col-1 text-center" v-if="userStore.User.can_check_skill_cards || KNOLIA.isAdmin()">Cédula</span>
                </div>

                <div v-for="(user, i) in selectedList.users" :key="user.id" class="div-user" :class="{'bg-alt-line': i % 2 == 0}">
                    <div class="row col-11" @mouseenter="UserInfoTooltip(user, $event.target)">
                        <span class="col-6 cursor-default">{{ user.name }}</span>
                        <span class="col-3 text-center cursor-default">{{ user.proficiency_average}}</span>
                        <span class="col-2 text-center cursor-default">{{ user.validation_average_percent + '%' ?? '--'}}</span>
                    </div>
                    <i class="col-1 fas fa-address-card cursor-pointer text-center" @mouseenter="Gems.Tooltip($event.target, 'Cédula de competências', 'tooltip')" @click="ToSkillCard(user)" 
                        v-if="user.is_logged_user || userStore.User.can_check_skill_cards || KNOLIA.isAdmin() || (!userStore.User.can_check_skill_cards && user.is_subordinate)"></i>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="d-flex gap-2 col-auto align-items-center">
                <input type="checkbox" id="check-all-lists" class="cursor-pointer" @click="CheckAllLists($event.target.checked)"/>
                <label for="">Selecionar todas as listas</label>
            </div>
            <div class="col-2">
                <button class="ddl-alt-padding w-100" @click="ExportLists()">Exportar Lista(s)</button>
            </div>
        </div>
    </div>
</template>

<style scoped>

.div-default-title {
    font-size: inherit;
}

.div-container {
    margin-top: 1%;
}

.list {
    overflow-y: scroll;
    height: 400px;
}

.div-header, 
.div-user,
.div-list {
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.div-header {
    padding: 0px 5px;
}

.div-user i {
    font-size: 1.5em;
}

.div-list div {
    flex: 1;
    display: flex;
    gap: 10px;
}

</style>
